<div class="" #wrapper style="position:relative;">
  <div style="
    color: #fc390c;
    position: absolute;
    right: 0;
    top: -10px;
    border-radius: 20px;
    border: 1px solid;
    line-height: 6px;
    z-index: 1000;
    cursor: pointer;
" *ngIf="genericDialogData.displayBackLink">
    <mat-icon class="back-link mat-icon material-icons" (click)="backClick()">close</mat-icon>
  </div>
  <div class="row" style="margin-top: 10px;">
    <div class="col" style="text-align: center;">
      <h2 class="border-header" style="display:inline-block; padding-bottom: 3px;">{{genericDialogData.title}}</h2>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <pre>{{genericDialogData.content}}</pre>
    </div>
  </div>
  <div class="row">
    <div class="col" style="text-align: center;">
      <app-button
        *ngFor="let button of genericDialogData.buttons; let i = index"
        [buttonStyle]="{marginRight: i == 0 ? '5px' : '', paddingLeft: '15px', paddingRight: '15px'}"
        (click)="buttonClicked(i)"
        [styleType]="genericDialogData.buttonStyles[i] ? genericDialogData.buttonStyles[i] : i > 0 ? 'secondary' : ''"
      >{{button}}
      </app-button>
    </div>
  </div>
</div>
